import { Component, Output, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
//import { Component } from '@angular/core';

import * as XLSX from 'xlsx';

type AOA = any[][];

@Component({
  selector: 'app-uploadmaterial',
  templateUrl: './uploadmaterial.component.html',
  styleUrls: ['./uploadmaterial.component.less']
})
export class UploadmaterialComponent  {
  fileSize: number;
 constructor(private modalService: BsModalService){
  
 }
  data: AOA = [];

  fileNameofXls:string;
  //@Output() nameEmitter:EventEmitter<any> = new EventEmitter<any>();
  @Output() nameEmitter = new EventEmitter<object>();  
  
  PostData() {  
      this.nameEmitter.emit(this.data);  
      // console.log(this.data);
     // this.materialService.materials=this.data;
  }
  Cancel(){
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }  
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      this.fileNameofXls=target.files[0].name;
      this.fileSize=target.files[0].size;
      // console.log(target.files[0].name);
      // console.log(target.files[0].size);

      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      // console.log("data:",this.data);
      this.data.map(res=>{
        if(res[0] === "no"){
          // console.log(res[0]);
        }else{
          // console.log(res[0]);
        }
      })
    };
    reader.readAsBinaryString(target.files[0]);
  }


  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


}
